import React from 'react';
import type { FC } from 'react';
import { Link } from 'react-router-dom';
import WorkOutlineIcon from '@material-ui/icons/WorkOutline';
import { routes } from '@/constants';
import ReservationDates from '../ReservationDates';
import { SearchCard, SearchCardContent, SearchCardDetails, SearchCardIcon } from './Sidebar.styled';

interface Props {
  readonly reservationId: string;
  readonly startDate: Date | string;
  readonly endDate: Date | string;
  readonly customerFirstName?: string;
  readonly customerLastName?: string;
  readonly propertyName: string;
}

const SidebarReservationCard : FC<Props> = ({ reservationId, startDate, endDate, propertyName, customerFirstName, customerLastName }) => {
  const reservationUrl = routes.reservation(reservationId);

  return (
    <Link to={reservationUrl}>
      <SearchCard>
        <SearchCardIcon>
          <WorkOutlineIcon />
        </SearchCardIcon>

        <SearchCardContent>
          <div>
            { customerFirstName } { customerLastName }
          </div>

          <SearchCardDetails>
            <ReservationDates
              formatter="dd.MM.yyyy"
              startDate={startDate}
              endDate={endDate}
            />
          </SearchCardDetails>


          <SearchCardDetails>
            { propertyName }
          </SearchCardDetails>
        </SearchCardContent>
      </SearchCard>
    </Link>
  );
};

export default SidebarReservationCard;
